import "./App.css";
import GlobalUI from "./GlobalUI";

function App() {
  return (
    <div className="App">
      <GlobalUI />
    </div>
  );
}

export default App;
